<!-- 压缩包打开 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">基于儿童立场的小学语文文言文基于儿童立场的小学语文文言文基于儿童立场的小学语文文言文基于儿童立场的小学语文文言文</p>
		</div>

		<img src="../assets/icon-94.png" class="img-1">
		<span class="font-1">暂不支持预览此类型文件</span>
		<span class="font-2">请尝试下载文件后用其他应用打开</span>

		<button type="button" class="btn-1">提取下载链接</button>

		<p class="row-1">
			<img src="../assets/icon-93.png">
			建议提取下载连接后在PC浏览器中打开
		</p>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		min-height: 100vh;
		background-color: #fff;
	}

	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 115px 15px 15px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		width: 100%;
		text-align: center;
		padding-left: 38px;
		padding-right: 20px;
		box-sizing: border-box;
		color: #333333;
		font-size: 18px;
		font-weight:bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.img-1 {
		width: 74px;
		margin-bottom: 16px;
	}

	.font-1 {
		color: #222222;
		font-size: 14px;
		font-weight: bold;
	}

	.font-2 {
		color: #888888;
		font-size: 11px;
		margin-top: 8px;
	}

	.btn-1 {
		width: 155px;
		height: 46px;
		border: 1px solid #2A63F3;
		background-color: #FFFFFF;
		border-radius: 50px;
		color: #2A63F3;
		font-size: 15px;
		font-weight: bold;
		margin-top: 93px;
	}

	.row-1 {
		color: #666666;
		font-size: 11px;
		display: flex;
		align-items: center;
		margin-top: 24px;
	}

	.row-1>img {
		width: 14px;
		margin-right: 2px;
	}
</style>
